import React from 'react'
import { editor as editorJs } from '../editor.local.methods'
import deepEqual from 'fast-deep-equal'

interface Action {
    actionType: string
    actionOptions: any
}

interface Editor {
    setActionsOnContent: (data: EventType[]) => void
    deleteActionOnContent: (event: string, action: string) => void
}

interface EventType {
    eventType: string
    actions?: Action[]
}

interface Content {
    actionsOnContent: EventType[]
}

interface EditorActionsMethodsProps {
    content: Content
    currentPage: {
        id: number
        name: string
        order: number
        playOnEvent: {
            events: {
                id: string
                eventType: string
                key: string
                eventCondition: { key: string; value: string }
            }[]
        }
    }
    pages: object[]
}

interface EditorActionsMethodsState {
    isOpenModal: boolean
    action:
        | {
              eventType: string
              id: string
              actionOptions: { key: string; value: number }
              actionIndex: number
          }
        | {}
    content: Content
}

class EditorActionsMethods extends React.PureComponent<EditorActionsMethodsProps, EditorActionsMethodsState> {
    state: EditorActionsMethodsState = {
        isOpenModal: false,
        content: { actionsOnContent: [] },
        action: {},
    }

    static getDerivedStateFromProps(nextProps: EditorActionsMethodsProps, nextState: EditorActionsMethodsState) {
        if (!deepEqual(nextProps.content, nextState.content)) {
            return {
                content: nextProps.content,
            }
        }

        return null
    }

    onSave = (actionsOnContent: EventType, actionIndex?: number) => {
        const s_ = this.state
        let data: EventType[] = [actionsOnContent]
        const editor = editorJs as Editor

        if (s_.content.actionsOnContent) {
            data = s_.content.actionsOnContent.map((type) => {
                if (typeof actionIndex === 'number' && type.actions && actionsOnContent.actions) {
                    type.actions[actionIndex] = actionsOnContent.actions[0]
                } else if (type.eventType === actionsOnContent.eventType && type.actions && actionsOnContent.actions) {
                    type.actions.push(...actionsOnContent.actions)
                }

                return type
            })
        }

        this.setState({ isOpenModal: false })
        editor.setActionsOnContent(data)
    }
    onDelete = (event: string, action: string) => {
        const editor = editorJs as Editor
        editor.deleteActionOnContent(event, action)
    }
}

export default EditorActionsMethods
